import * as React from 'react';
import _ from 'lodash';
import { IOrderedItem } from '../../../models';

export const ResponseOptionsTooltipContent = (
	headingDisplayText: string,
	responseOptions: string[],
	descriptionDisplayText?: string,
): JSX.Element => (
	<div>
		<strong>{headingDisplayText}</strong>
		{descriptionDisplayText !== undefined && <p>{descriptionDisplayText}</p>}
		<ul>
			{responseOptions !== undefined &&
				responseOptions.map((ro: string, index) => (
					<li key={index} className='response-option'>
						{ro}
					</li>
				))}
		</ul>
	</div>
);

// NOTE: this is a simple override for situations where we ONLY need tooltip content
export const ResponseOptionsByOrderedItemTooltipContent = (displayText: string, responseOptions: IOrderedItem[]): JSX.Element => {
	const orderedResponseOptions = _.orderBy(responseOptions, ['displayOrder'], ['desc']);
	const responseOptionDisplayNames = _.map(orderedResponseOptions, (o: IOrderedItem) => o.displayText);
	return ResponseOptionsTooltipContent(displayText, responseOptionDisplayNames);
};
